// Remittance Transactions Vuex

import state from './remittanceTransactionStates.js'
import * as getters from './remittanceTransactionGetters.js'
import * as mutations from './remittanceTransactionMutations.js'
import * as actions from './remittanceTransactionActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
